import { RotaInstanceStatus } from 'screens/Rostering/types'
import styled from 'styled-components'
import {
  CanceledIcon,
  DoneIcon,
  DraftIcon,
  DueIcon,
  InProgressIcon,
  OverdueIcon,
  PendingIcon
} from './icons'

type EventIconProps = { status: RotaInstanceStatus }

const statusToIconMap: Record<RotaInstanceStatus, React.FC> = {
  [RotaInstanceStatus.DRAFT]: DraftIcon,
  [RotaInstanceStatus.PENDING]: PendingIcon,
  [RotaInstanceStatus.DUE]: DueIcon,
  [RotaInstanceStatus.IN_PROGRESS]: InProgressIcon,
  [RotaInstanceStatus.OVERDUE]: OverdueIcon,
  [RotaInstanceStatus.DONE]: DoneIcon,
  [RotaInstanceStatus.CANCELLED]: CanceledIcon
}

const EventIcon = ({ status }: EventIconProps) => {
  const SelectedIcon = statusToIconMap[status] || PendingIcon

  return (
    <Container>
      <SelectedIcon />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
`

export default EventIcon
